import { DisputesCenterTabMap, OpenDisputesTabMap } from './constants';

export function getDisputesTabMap (path: string) {
  return DisputesCenterTabMap[path.substr(path.lastIndexOf('/') + 1)];
}

export function getOpenDisputesTabMap (path: string) {
  return OpenDisputesTabMap[path.substr(path.lastIndexOf('/') + 1)];
}
